import { gettext, modals, notifications } from '@bikemap/js/services'
import { initTrainingLogForm, submitTrainingLogEntry } from '@bikemap/js/legacy/training-log'
import { defaultPost } from '@bikemap/js/utility'

/**
 * TODO: Replace this context workaround by imports, when functions and constants are extracted into modules!
 */
let isOwner, changeSubTab
export function initTrainingLogContext(context) {
    isOwner = context.isOwner
    changeSubTab = context.changeSubTab
}

function indicateTrainingLogChange() {
    document.getElementById('training-log-main-link').dataset.dirty = true
    document.getElementById('all-trainings-link').dataset.dirty = true
}

function handleEditSubmit(e, modal) {
    modal.setLoading()
    submitTrainingLogEntry(modal.content)
        .then(res => {
            modal.setLoading(false)
            if (res.success) {
                modals.close()
                if (res.callback_params.edited) indicateTrainingLogChange()
                changeSubTab($('#training-log-main-link'), 'training-log', undefined, true)
            }
        })
        .catch(res => notifications.error(res.statusText))
}

function handleEditTrainingBtn(e) {
    e.preventDefault()
    modals.load('edit-training', {
        url: e.target.href,
        headers: isOwner
            ? { 'Is-Owner': 'True', 'Bypass-It': 'True' }
            : { 'Bypass-It': 'True' },
    }, {
        title: gettext('Edit training entry'),
        icon: 'timeline',
        focus: '#id_title',
        buttons: [
            { content: gettext('Cancel'), action: 'close' },
            { content: gettext('Save'), style: 'primary', action: 'submit' },
        ],
        init: modal => initTrainingLogForm(modal.content),
        onSubmit: handleEditSubmit,
    })
}

function handleDeleteSubmit(e, modal) {
    defaultPost(modal.referrer.href)
        .then(res => {
            // TODO: Find a clearer implementation with new tiles
            $(modal.referrer).parents('.mix-category-1').remove()

            notifications.show({
                title: res.callback_params.finished.title,
                icon: 'i-check',
                message: res.callback_params.finished.content,
                type: 'success',
            })

            indicateTrainingLogChange()
        })
        .catch(res => notifications.error(res.statusText))
        .finally(() => modals.close())
}

function handleDeleteTrainingBtn(e) {
    e.preventDefault()
    modals.show('delete-training', {
        title: gettext('Delete training entry'),
        message: gettext('Do you really want to remove this training entry?'),
        buttons: [
            { content: gettext('Cancel'), action: 'close' },
            { content: gettext('Confirm'), style: 'danger', action: 'submit' },
        ],
        onSubmit: handleDeleteSubmit,
        referrer: e.target,
    })
}

export function initTrainingItemButtons() {
    const editButtons = document.querySelectorAll('.edit-training')
    for (let i = 0; i < editButtons.length; i++) {
        editButtons[i].addEventListener('click', handleEditTrainingBtn)
    }
    const deleteButtons = document.querySelectorAll('.delete-training')
    for (let i = 0; i < deleteButtons.length; i++) {
        deleteButtons[i].addEventListener('click', handleDeleteTrainingBtn)
    }
}

function handleTrainingEntrySubmit(e) {
    e.preventDefault()
    submitTrainingLogEntry(e.target)
        .then(res => {
            if (res.success) {
                indicateTrainingLogChange()
                changeSubTab($('#training-log-main-link'), 'training-log', undefined, true)
            }
        })
}

export function initTrainingEntryTab() {
    const trainingForm = document.querySelector('#training-edit-form')
    initTrainingLogForm(trainingForm)
    trainingForm.removeEventListener('submit', handleTrainingEntrySubmit)
    trainingForm.addEventListener('submit', handleTrainingEntrySubmit)
}
